import { useCallback, useState } from 'react';

export function useForceUpdate() {
  const [, setValue] = useState<object>({});

  return useCallback(() => setValue({}), []);
}
